import { useNavigate } from "react-router-dom";
import {
    IoArrowBack,
    IoArrowForward,
    IoChevronDown,
    IoPeopleOutline,
    IoPhonePortraitOutline,
    IoSparklesOutline,
    IoStarOutline,
} from "react-icons/io5";

const GRID_ITEMS = [
    {
        id: "local-feed",
        type: "feature",
        icon: IoSparklesOutline,
        title: "Local feed",
        description: "A short-form feed built around your city, so you can discover relevant content from the people and places around you.",
    },
    {
        id: "run-club",
        type: "image",
        src: "https://images.unsplash.com/photo-1571019613914-85f342c6a11e?w=900&auto=format&fit=crop&q=60",
        alt: "People exercising together outdoors",
    },
    {
        id: "community-chat",
        type: "feature",
        icon: IoPhonePortraitOutline,
        title: "Community chat",
        description: "A real-time messaging space designed to bring people together for discussion and collaboration within your community.",
    },
    {
        id: "dance-event",
        type: "image",
        src: "https://images.unsplash.com/photo-1508700115892-45ecd05ae2ad?w=900&auto=format&fit=crop&q=60",
        alt: "Person dancing at a community event",
    },
    {
        id: "food-event",
        type: "image",
        src: "https://images.unsplash.com/photo-1555244162-803834f70033?w=900&auto=format&fit=crop&q=60",
        alt: "Neighborhood cookout",
    },
    {
        id: "neighborhood-news",
        type: "feature",
        icon: IoPeopleOutline,
        title: "Neighborhood news",
        description: "Transforming neighborhoods into connected digital communities.",
    },
    {
        id: "dog-owner",
        type: "image",
        src: "https://images.unsplash.com/photo-1548199973-03cce0bbc87b?w=900&auto=format&fit=crop&q=60",
        alt: "Dog owner in a neighborhood park",
    },
    {
        id: "explore-features",
        type: "cta",
        icon: IoStarOutline,
        title: "Explore more of our features",
    },
];

export default function WhatMakesDifferent() {
    const navigate = useNavigate();

    const handleCardClick = (itemType) => {
        if (itemType === "cta") {
            navigate("/our-features");
        }
    };

    return (
        <div className="relative flex h-full w-full flex-col overflow-hidden">
            {/* Back arrow — mobile only */}
            <button
                onClick={() => navigate(-1)}
                className="flex md:hidden items-center gap-1.5 px-4 pt-4"
            >
                <IoArrowBack className="text-[22px]" />
            </button>

            <div className="flex flex-1 flex-col overflow-y-auto px-6 py-8 sm:px-10 lg:px-24 no-scrollbar">
                <div className="mb-7 w-fit rounded-xl border border-[#8BCDEE] bg-white px-6 py-3">
                    <span className="text-[15px] font-semibold text-[#1597CA]">What makes us different</span>
                </div>

                <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
                    {GRID_ITEMS.map((item) => {
                        if (item.type === "image") {
                            return (
                                <img
                                    key={item.id}
                                    src={item.src}
                                    alt={item.alt}
                                    draggable={false}
                                    loading="lazy"
                                    className="h-[220px] w-full rounded-[22px] object-cover"
                                />
                            );
                        }

                        if (item.type === "cta") {
                            const CtaIcon = item.icon;

                            return (
                                <button
                                    key={item.id}
                                    onClick={() => handleCardClick(item.type)}
                                    className="group flex h-[220px] w-full flex-col items-start rounded-[22px] border border-[#CFE8F8] bg-[#FAFDFF] p-4 text-left shadow-[0_2px_10px_rgba(22,123,176,0.08)] transition hover:bg-[#F2FAFF]"
                                >
                                    <CtaIcon className="text-[24px] text-[#2E9DDA]" />
                                    <p className="mt-5 text-[22px] font-black leading-[1.3] text-[#1E2429]">
                                        {item.title}
                                        <IoArrowForward className="ml-1 mt-1 inline text-[22px] align-[-2px] text-[#1E2429] transition group-hover:translate-x-1" />
                                    </p>
                                </button>
                            );
                        }

                        const Icon = item.icon;

                        return (
                            <article
                                key={item.id}
                                className="flex h-[220px] w-full flex-col rounded-[22px] border border-[#CFE8F8] bg-[#FAFDFF] p-4 shadow-[0_2px_10px_rgba(22,123,176,0.08)]"
                            >
                                <Icon className="text-[24px] text-[#2E9DDA]" />
                                <h3 className="mt-4 text-[18px] font-black leading-[1.2] text-[#1E2429]">{item.title}</h3>
                                <p className="mt-3 text-[14px] text-[#6A737C]">{item.description}</p>
                            </article>
                        );
                    })}
                </div>
            </div>

            <div className="flex items-center justify-center pb-6">
                <button
                    onClick={() => navigate("/about-us/early-community")}
                    className="flex items-center gap-1.5 text-[14px] font-semibold text-[#2E9DDA] hover:underline"
                >
                    Be part of the early community
                    <IoChevronDown className="text-[15px]" />
                </button>
            </div>
        </div>
    );
}
